<template>
    <div @click="dismiss()" :class="{ 'popover-disabled': disabled }" :data-delay="delayObjectStr" ref="popover">
        <slot></slot>
    </div>
</template>

<script>
import Utilities from "@/assets/js/utilities.js"

export default {
    name: "InfoPop",
    props: {
        content: {
            type: String,
            required: true,
        },
        justify: {
            type: String,
            default: "center",
            required: false,
        },
        placement: {
            type: String,
            required: false,
            default: null,
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false,
        },
        dismissOnClick: {
            type: Boolean,
            required: false,
            default: false,
        },
        delay: {
            type: Number,
            required: false,
            default: 0,
        },
    },
    computed: {
        justifyClass() {
            if (this.justify == "center") {
                return "text-center"
            } else if (this.justify == "right") {
                return "text-right"
            }
            return "text-left"
        },
        delayObjectStr() {
            return `{ "show": ${this.delay}, "hide": 0 }`
        },
    },
    watch: {
        content: function () {
            $(this.$refs.popover).popover("dispose")
            this.init()
        },
    },
    methods: {
        init() {
            let isMobile = Utilities.isMobileDevice()
            let config = {
                boundary: "window",
                customClass: this.justifyClass + " shadow-sm",
                content: this.content,
                // On mobile, trigger via click.
                trigger: isMobile ? "click" : "hover",
            }
            if (this.placement) {
                config.placement = this.placement
            }
            $(this.$refs.popover).popover(config)
        },
        dismiss() {
            if (this.dismissOnClick) {
                $(this.$refs.popover).popover("hide")
            }
        },
    },
    mounted() {
        this.init()
    },
    beforeDestroy() {
        // Kill the popover if the component is removed.
        $(this.$refs.popover).popover("dispose")
    },
}
</script>

<style lang="scss" scoped>
.popover-disabled {
    pointer-events: none;
}
</style>
